import { render, staticRenderFns } from "./StudentProfile.vue?vue&type=template&id=2ac9f0a3&"
import script from "./StudentProfile.vue?vue&type=script&lang=js&"
export * from "./StudentProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports